import { Component, inject, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Alert, MsgType, MsgTypeText } from 'src/app/Interfaces/alerts';
import { AlertService } from 'src/app/services/alert.service';

@Component({
	selector: 'app-alert-dialog',
	templateUrl: './alert-dialog.component.html',
	styleUrls: ['./alert-dialog.component.scss'],
})
export class AlertDialogComponent implements OnDestroy, OnInit {
	private dialogRef = inject(MatDialogRef<AlertDialogComponent>);
	private _alert = inject(AlertService);

	constructor(@Inject(MAT_DIALOG_DATA) public data: { alerts: Alert[]; confirmAction?: boolean; confirmActionWithoutCancel?: boolean }) {}

	ngOnInit(): void {
		if (this.shouldBlock) {
			this._alert.handleToggleBlurRootElement({ forceState: 'blur' });
		}
	}

	ngOnDestroy(): void {
		if (this.shouldBlock) {
			history.back();
		}
	}

	messages = this.data.alerts.map(alert => alert.Msg);

	shouldBlock = this.data.alerts.some(alert => alert.JSON.block);

	onNoClick(): void {
		this.dialogRef.close(false);
	}
	onYesClick(): void {
		this.dialogRef.close(true);
	}
}
